// 左边将视作正则表达式
const options: Record<string, string[]> = {
  // dev: ['/dashboard'],
  // '.*': ['/dashboard']
}

export default options
